import api from "../api";

export const usuariosLogadosService = {
  listar(params) {
    return api.get("/usuarios-logados", { params });
  },
  encerrarSessaoAtual() {
    return api.post("/usuarios-logados/encerrar-atual");
  },
  encerrarSessoes(codigosUsuarios) {
    return api.post("/usuarios-logados/encerrar", { codigosUsuarios });
  },
};
